module.exports = __webpack_public_path__ + "img/背景.ee386ced.png";